module.exports = __webpack_public_path__ + "static/media/usb-mini-silver.4d0918af.svg";